import * as React from "react";

function SvgSlant1Inverted(props) {
  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1600 200" {...props}><path d="M1610 210H-10V.5l1620 183.4z" /></svg>;
}

export default SvgSlant1Inverted;